var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave33(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83.592,
    height: 83.592,
    viewBox: "0 0 83.592 83.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_628",
    x: 0,
    y: 0,
    width: 83.592,
    height: 83.592,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_79_23",
    "data-name": "Component 79 \\u2013 23",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_628-2",
    "data-name": "Ellipse 628",
    transform: "translate(9 6)",
    fill: "#fff",
    stroke: "#ffca3a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.796,
    cy: 32.796,
    rx: 32.796,
    ry: 32.796,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.796,
    cy: 32.796,
    rx: 32.296,
    ry: 32.296,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_33_Save",
    "data-name": "33 %  Save",
    transform: "translate(32.473 27.205)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "GoogleSans-Regular, Google Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18,
    y: 0
  }, "33 % "), /*#__PURE__*/React.createElement("tspan", {
    x: -17,
    y: 20
  }, "Save")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave33);
export default __webpack_public_path__ + "static/media/save-33.a33de169ead8d468f0e41346c841b3f4.svg";
export { ForwardRef as ReactComponent };